import {Int} from '@store/@types/util';
import {List} from 'immutable';

// eslint-disable-next-line
const regexpEscape = s => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
const tokenBoundaryRegExp = '[\\s\\.\\,]+';

interface MatchResult {
  matchingText: string;
  begin: Int;
  end: Int;
}

/**
 Returns an array of match locations, ignoring punctuation, spaces, and casing
   e.g. 'dog     house' and 'dog... HOUSE' will match 'dog house'
*/
export default function createMatchFinder(textToSearchFor): (search: string) => List<MatchResult> {
  const tokenizedSearchString = textToSearchFor.split(new RegExp(tokenBoundaryRegExp));
  const searchRegExp = new RegExp(
    tokenizedSearchString.map(regexpEscape).join(tokenBoundaryRegExp),
    'ig'
  );
  return textToSearchAgainst => {
    let results = List<MatchResult>();
    let result;
    while ((result = searchRegExp.exec(textToSearchAgainst))) {
      results = results.push({
        matchingText: result[0],
        begin: result.index,
        end: result.index + result[0].length,
      });
    }
    return results;
  };
}
